var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOutboundEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#9258E7",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26 10H10c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h9v-2h-9V14l8 5 8-5v5h2v-7c0-1.1-.9-2-2-2zm-8 7l-8-5h16l-8 5zm7 4l4 4-4 4v-3h-4v-2h4v-3z",
    fill: "#5D43CF"
  })));
}

export default __webpack_public_path__ + "05ac0acca194b73c4948eb7ae99f636b.svg";
export { SvgOutboundEmail as ReactComponent };